import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import { addFileType } from '../../actions/fileData';
import { Button, Form, Row, Col, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle, TabContent, TabPane, Nav, NavItem, NavLink, } from 'reactstrap';
import MetaDataValues from './Metavalues'
import FileTypeOrder from './FileTypeOrder'
import classnames from 'classnames';
import {fileMetaDataValueFetchData, fileMetaDataCategoryFetchData} from '../../actions/fileData'
class fileTypeForm extends Component {

    constructor(props,context) {
        super(props,context);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {postData: false, edit: false, 'fileType': false, metaCategories: [], activeTab: '1'}

        this.changeMetaCheckbox = this.changeMetaCheckbox.bind(this);
        this.setMetaMandatory = this.setMetaMandatory.bind(this);

        this.toggle = this.toggle.bind(this);
      
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
    }

    componentWillMount()
    {

        if(this.props.match.params.categoryid)
        {
            const categoryId = this.props.match.params.categoryid;
            const fileType = this.props.fileTypeData.data.find(e => e.id === categoryId);
            this.setState({
                edit: true, 
                postData: fileType, 
                fileType: fileType, 
                metaCategories: fileType.metacategories
            })
        }

        if(this.props.clientPath.clientPath) {
            this.props.fileMetaDataCategoryFetchData(this.props.clientPath.clientPath)
        }
    }

    handleSubmit(e) {
        e.preventDefault();


        this.props.addFileType(
            this.props.clientPath.clientPath,
            this.state.postData,
            this.state.metaCategories

        );
    }

    setInputState(e) {
      this.setState({
          postData: {...this.state.postData, [e.target.name]: e.target.value }

      });
    }

    setCheckedValue(e) {
        this.setState({
            postData: {...this.state.postData, [e.target.name]: e.target.checked ? 1 : 0 }
        })
    }

    changeMetaCheckbox(e, metaCategoryId) {


        let metaCategories = this.state.metaCategories;

        // -- Check if value is in array.
        let itemWasFound = false;
        for(let i = 0; i <= metaCategories.length; i++) {
            if(metaCategories[i]) {
                if(metaCategories[i]['id'] === metaCategoryId) {
                    itemWasFound = true
                    if(!e.target.checked) {
                        metaCategories.splice(i, 1);
                        document.getElementById('is_mandatory_'+metaCategoryId).checked = false;
                    }
                }
            }
        }
        if(e.target.checked && !itemWasFound) {
            metaCategories.push({id: metaCategoryId, is_mandatory: '0'});
        }

        this.setState({
            ...this.state,
            metaCategories
        })
       
    }

    setMetaMandatory(e, metaCategoryId) {
        let metaCategories = this.state.metaCategories;

        // -- Check if value is in array.
        let itemWasFound = false;
        for(let i = 0; i <= metaCategories.length; i++) {
            if(metaCategories[i]) {
                if(metaCategories[i]['id'] === metaCategoryId) {
                    itemWasFound = true
                    if(metaCategories[i]['is_mandatory'] == '0') {
                        metaCategories[i]['is_mandatory'] = '1';
                    }else{
                        metaCategories[i]['is_mandatory'] = '0';
                    }

                }
            }
        }
        if(e.target.checked && !itemWasFound) {
            metaCategories.push({id: metaCategoryId, is_mandatory: '1'});
            document.getElementById('metacategory_'+metaCategoryId).checked = true;
        }

        this.setState({
            ...this.state,
            metaCategories
        })
    }

    render() {

        return (
            <div className="animated fadeIn">
             <Card>
                <CardBody>
                    <CardTitle><i className="fa fa-file"></i> Bestands type {this.state.edit ? 'bewerken' : 'toevoegen'}</CardTitle>
                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                        <FormGroup>
                            <Label for="category">Type</Label>
                            <Input type="text" defaultValue={this.state.fileType ? this.state.fileType.type : null} onChange={(e) => this.setInputState(e)} name="type" id="type" placeholder="Bestands type" />
                        </FormGroup>
                        <FormGroup check>
                            <Label check for="is_active">
                                <Input type="checkbox" defaultChecked={this.state.fileType && this.state.fileType.is_active === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_active" id="is_active" />
                                Is actief?
                            </Label>
                        </FormGroup>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: this.state.activeTab === '1' })}
                              onClick={() => { this.toggle('1'); }}
                            >
                              Koppel metadatacategorie
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: this.state.activeTab === '2' })}
                              onClick={() => { this.toggle('2'); }}
                            >
                              Volgorde bestandstype
                            </NavLink>
                          </NavItem>
                        </Nav>  
                        <TabContent activeTab={this.state.activeTab}>
                          <TabPane tabId="1">
                            <Row>
                              <Col sm="12">                      
                                <FormGroup>
                                    {this.props.fileMetaDataCategories.data ? <MetaDataValues currentFile={this.state.fileType ? this.state.fileType : false} setMetaMandatory={this.setMetaMandatory} changeMetaCheckbox={this.changeMetaCheckbox}/> : null}
                                </FormGroup>
                              </Col>
                            </Row>
                          </TabPane>
                          { this.props.match.params.categoryid ? 
                          <TabPane tabId="2">
                            <Row>
                              <Col sm="12">

                               <FileTypeOrder categoryid={this.props.match.params.categoryid} />
                              </Col>
                            </Row>
                          </TabPane>
                          : '' }
                        </TabContent>
                        <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-dot-circle-o"></i> {this.state.edit ? 'Bijwerken' : 'Toevoegen'}</button>
                    </Form>
                </CardBody>
            </Card>

            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        fileTypeData: state.FileTypeDataReducer,
        clientPath: state.clientPathReducer,
        fileMetaDataCategories: state.FileMetaDataCategoryReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFileType: (url, postData, metaCategories) => dispatch(addFileType(url, postData, metaCategories)),
        fileMetaDataCategoryFetchData: (url) => dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories')),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(fileTypeForm))



// WEBPACK FOOTER //
// ./src/views/Filetype/form.js